// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__tRELu","search":"Settings_search__2cv6O","filter":"Settings_filter__2-o-L"};